/*
 * marking-labels/app.js — страница /marking-labels.
 *
 * Поток: файлы/вставка/камера → MarkingInput (чтение) → MarkingCodes.batch
 * (проверка партии) → шаблон (MarkingTemplates) → раскладка, превью и PDF —
 * ядро /label-maker (layout.js, render.js, pdf.js), DataMatrix — в точках
 * принтера (label-maker/matrix.js). Карточки товаров и партия с пометками
 * «напечатано» живут в хранилище работы этого браузера (__workStorage).
 *
 * Кап: единица — входной файл с кодами (ключ файла), коды без файла —
 * составной ключ операции; списывает только выданный PDF или выгрузка.
 */
(function () {
    'use strict';
    var SLUG = 'marking-labels';
    var CFG = window.__MARKING || {};
    var I18N = CFG.i18n || {};
    var MC = window.MarkingCodes, MT = window.MarkingTemplates, MI = window.MarkingInput;
    var LS = window.LabelSheets, LL = window.LabelLayout, LR = window.LabelRender, LP = window.LabelPdf, LM = window.LabelMatrix, LD = window.LabelData;
    if (!MC || !MT || !MI || !LS || !LL || !LR || !LP || !LM || !LD) {
        try { window.__aeDiagnostic && window.__aeDiagnostic({ issue: 'ml_modules_missing' }); } catch (_) {}
        return;
    }

    function T(k, r) {
        var s = I18N[k] != null ? String(I18N[k]) : k;
        if (r) for (var p in r) if (Object.prototype.hasOwnProperty.call(r, p)) s = s.split(':' + p).join(String(r[p]));
        return s;
    }
    function $(id) { return document.getElementById(id); }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function nf(v, d) {
        try { return new Intl.NumberFormat(window.__intlLocale ? window.__intlLocale() : 'ru', { minimumFractionDigits: d || 0, maximumFractionDigits: d || 0 }).format(v); }
        catch (_) { return String(Math.round(v * Math.pow(10, d || 0)) / Math.pow(10, d || 0)); }
    }
    function toast(msg, type) { try { window.__toast && window.__toast(msg, type || 'info'); } catch (_) {} }
    function stage(n, m) { try { window.__stage && window.__stage(n, m || {}); } catch (_) {} }
    function feature(f, p) { try { window.__aeFeature && window.__aeFeature(f, p || {}); } catch (_) {} }
    function diag(issue, extra) { try { window.__aeDiagnostic && window.__aeDiagnostic(Object.assign({ issue: issue }, extra || {})); } catch (_) {} }

    var FAMILY = "'LM Noto Sans','Noto Sans',Arial,sans-serif";
    function familyFor() { return FAMILY; }

    /* ── состояние ───────────────────────────────────────────────────────── */
    var TS = window.__toolSettings;
    var S = {
        sources: [],                       // {id, name, kind, key, items, pages, missed, notGs1, note, busy, error}
        batch: null,
        tpl: TS ? TS.load(SLUG, 'tpl', 'cz') : 'cz',
        size: TS ? TS.load(SLUG, 'size', 'roll-58x40') : 'roll-58x40',
        // Лента, которую ВЫБРАЛ человек. Шаблон, которому она мала, временно
        // берёт другую (S.size), но выбор не перезаписывает: вернулся к «Только
        // ЧЗ» — вернулась и 58×40. До 23.10 подмена сохранялась, и следующая
        // печать уходила на 58×60 при заправленной 58×40.
        sizePref: null,
        sheet: TS ? TS.load(SLUG, 'sheet', 'mk-58x40') : 'mk-58x40',
        cw: TS ? TS.load(SLUG, 'cw', 58) : 58,
        ch: TS ? TS.load(SLUG, 'ch', 40) : 40,
        dpi: +(TS ? TS.load(SLUG, 'dpi', 203) : 203) || 203,
        dots: TS ? TS.load(SLUG, 'dots', 'auto') : 'auto',
        // КИ текстом: 'auto' — печатается, если помещается («(01)…», иначе «01…»,
        // иначе без КИ); 'on' — всегда (не влезло — предупреждение); 'off' — нет.
        kiMode: (function () { var v = TS ? TS.load(SLUG, 'kimode', 'auto') : 'auto'; return v === 'on' || v === 'off' ? v : 'auto'; })(),
        eac: false,
        // Поправка принтера: сдвиг всей этикетки, мм (вправо, вниз), кратный точке.
        corr: (function () { var c = TS ? TS.load(SLUG, 'corr', null) : null; return c && typeof c === 'object' ? { dx: +c.dx || 0, dy: +c.dy || 0 } : { dx: 0, dy: 0 }; })(),
        range: 'all', filter: 'all',
        selected: {}, printed: {},
        idx: 0,
        cards: {},
        geom: null,
        lastJob: null,
        camMode: 'verify',
        verify: { seen: {}, foreign: {}, notGs1: {}, order: [] },
    };
    var nextId = 1;
    var encCache = {}, bwip = null, measure = null, barcodeCache = {}, barcodePending = {};

    function saveSetting(k, v) { if (TS) TS.save(SLUG, k, v); }

    /* ── хранилище работы: карточки и партия ─────────────────────────────── */
    var store = null;
    function openStore() {
        if (store) return store;
        if (!window.__workStorage) { store = Promise.resolve(null); return store; }
        store = window.__workStorage.open('timbrica_marking_labels', 1, function (db) {
            if (!db.objectStoreNames.contains('cards')) db.createObjectStore('cards');
            if (!db.objectStoreNames.contains('batch')) db.createObjectStore('batch');
        }).then(function (h) { return h.db; }, function () { return null; });
        return store;
    }
    function dbPut(name, key, val) {
        return openStore().then(function (db) {
            if (!db) return false;
            return new Promise(function (res) {
                var t = window.__workStorage.tx(db, name);
                t.objectStore(name).put(val, key);
                t.oncomplete = function () { res(true); };
                t.onerror = t.onabort = function () { res(false); };
            });
        });
    }
    function dbDel(name, key) {
        return openStore().then(function (db) {
            if (!db) return false;
            return new Promise(function (res) {
                var t = window.__workStorage.tx(db, name);
                t.objectStore(name).delete(key);
                t.oncomplete = function () { res(true); };
                t.onerror = t.onabort = function () { res(false); };
            });
        });
    }
    function dbAll(name) {
        return openStore().then(function (db) {
            if (!db) return {};
            return new Promise(function (res) {
                var out = {}, t = db.transaction(name, 'readonly'), st = t.objectStore(name);
                var c = st.openCursor();
                c.onsuccess = function () { var cur = c.result; if (cur) { out[cur.key] = cur.value; cur.continue(); } };
                t.oncomplete = function () { res(out); };
                t.onerror = t.onabort = function () { res(out); };
            });
        });
    }

    var saveBatchTimer = null;
    function saveBatchSoon() {
        clearTimeout(saveBatchTimer);
        saveBatchTimer = setTimeout(saveBatch, 400);
    }
    function saveBatch() {
        if (!S.sources.length) { dbDel('batch', 'current'); return; }
        var rec = {
            savedAt: Date.now(),
            sources: S.sources.filter(function (s) { return !s.busy; }).map(function (s) {
                return {
                    name: s.name, kind: s.kind, key: s.key, pages: s.pages || 0, note: s.note || null, notGs1: s.notGs1 || 0,
                    missed: s.missed || [],
                    codes: s.items.map(function (it) { return { c: it.code || it.input, p: it.page || null, l: it.line || null, s: it.symbology || null }; }),
                };
            }),
            printed: S.printed,
        };
        dbPut('batch', 'current', rec);
    }

    var saveCardsTimer = null;
    function saveCard(gtin) {
        clearTimeout(saveCardsTimer);
        saveCardsTimer = setTimeout(function () { dbPut('cards', gtin, S.cards[gtin] || {}); }, 300);
    }

    /* ── источники ───────────────────────────────────────────────────────── */
    function fileKey(file) {
        try { return window.__toolLimit && window.__toolLimit.fileKey ? window.__toolLimit.fileKey(file) : null; } catch (_) { return null; }
    }
    function setKeyFor(prefix, items) {
        var codes = items.map(function (it) { return it.code || it.input; }).sort();
        return 'set:' + prefix + ':' + MC.hash(codes.join('\n'));
    }

    function addFiles(files) {
        Array.prototype.forEach.call(files || [], function (f) { addFile(f); });
    }

    function addFile(file) {
        var key = fileKey(file);
        if (key && S.sources.some(function (s) { return s.key === key; })) {
            toast(T('file_already', { name: file.name }), 'info');
            return;
        }
        var src = { id: nextId++, name: file.name || 'file', kind: 'file', key: key, items: [], busy: true, progress: '' };
        S.sources.push(src);
        renderSources();
        stage('file_picked', { ext: (String(file.name).split('.').pop() || '').toLowerCase().slice(0, 5) });
        var t0 = Date.now();
        MI.read(file, {
            onProgress: function (done, total) { src.progress = T('reading_pages', { done: done, total: total }); renderSources(); },
        }).then(function (r) {
            src.busy = false;
            src.kind = r.kind; src.items = r.items || []; src.pages = r.pages || 0;
            src.missed = r.missed || []; src.notGs1 = r.notGs1 || 0; src.note = r.note || null;
            src.badLines = r.badLines || []; src.skipped = r.skipped || 0;
            src.items.forEach(function (it) { it.source = src.name; it.srcId = src.id; });
            if (!src.items.length) src.error = r.kind === 'eps' ? 'eps_unreadable' : (r.kind === 'pdf' ? 'pdf_no_codes' : 'no_codes');
            stage('codes_read', { kind: r.kind, n: src.items.length, pages: src.pages, missed: src.missed.length, ms: Date.now() - t0 });
            if (src.missed.length) diag('ml_pdf_missed_codes', { n: src.missed.length, pages: src.pages });
            recompute();
        }).catch(function (err) {
            src.busy = false;
            src.error = (err && err.code === 'MEMORY') ? 'too_big' : 'read_failed';
            renderSources();
            if (window.__handleError) window.__handleError(err, 'ml_read_' + (String(file.name).split('.').pop() || 'x').toLowerCase().slice(0, 5), { say: T('err_read', { name: file.name }) });
            else toast(T('err_read', { name: file.name }), 'error');
            recompute();
        });
    }

    function addText(text, kind) {
        var r = MC.extract(text, kind === 'camera' ? T('src_camera') : T('src_paste'));
        if (!r.items.length) { toast(T(kind === 'camera' ? 'cam_nothing' : 'paste_nothing'), 'warning'); return 0; }
        var src = null;
        // Камера копит коды в один источник; вставка — новый источник на каждое «Добавить».
        if (kind === 'camera') src = S.sources.filter(function (s) { return s.kind === 'camera'; })[0] || null;
        if (!src) {
            src = { id: nextId++, name: kind === 'camera' ? T('src_camera') : T('src_paste_n', { n: S.sources.filter(function (s) { return s.kind === 'paste'; }).length + 1 }), kind: kind, items: [] };
            S.sources.push(src);
        }
        var have = {};
        src.items.forEach(function (it) { have[it.code || it.input] = 1; });
        var added = 0;
        r.items.forEach(function (it) {
            var k = it.code || it.input;
            if (kind === 'camera' && have[k]) return;
            it.source = src.name; it.srcId = src.id;
            src.items.push(it); added++;
        });
        src.badLines = (src.badLines || []).concat(r.badLines || []);
        src.key = setKeyFor(kind, src.items);
        stage('codes_read', { kind: kind, n: added, bad: (r.badLines || []).length });
        recompute();
        return added;
    }

    function removeSource(id) {
        S.sources = S.sources.filter(function (s) { return s.id !== id; });
        recompute();
    }

    /* ── партия ──────────────────────────────────────────────────────────── */
    function allItems() {
        var out = [];
        S.sources.forEach(function (s) { if (!s.busy) s.items.forEach(function (it) { out.push(it); }); });
        return out;
    }

    function recompute() {
        // Пометки ошибок партии (дубль КИ с другим хвостом) ставит batch() — перед
        // пересчётом снимаем их, иначе удалённый файл оставлял бы «ошибку» соседу.
        allItems().forEach(function (it) {
            if (it.issues.some(function (x) { return x.code === 'same_ki_other_tail'; })) {
                it.issues = it.issues.filter(function (x) { return x.code !== 'same_ki_other_tail'; });
                var lv = 'ok';
                it.issues.forEach(function (x) { if (x.level === 'error') lv = 'error'; else if (x.level === 'warn' && lv !== 'error') lv = 'warn'; });
                it.level = lv; it.ok = lv !== 'error' && !!it.code;
            }
        });
        S.batch = MC.batch(allItems());
        if (S.idx >= S.batch.printable.length) S.idx = Math.max(0, S.batch.printable.length - 1);
        // Широкий экран: коды партии стоят рядом с этикеткой — открываем их сами,
        // один раз (закрыл человек — его выбор).
        if (S.batch.total && !S.codesShown) {
            S.codesShown = true;
            var root = $('ml');
            if (root && root.getBoundingClientRect().width >= 1240) $('ml-codes-d').open = true;
        }
        renderSources();
        renderAnswer();
        renderCodes();
        renderCards();
        encodeAll().then(function () { updateGeometry(); renderPreview(); renderRange(); });
        saveBatchSoon();
    }

    /* Каждый код — в модули один раз (bwip-js), по 200 за такт, чтобы пачка
       в 500 кодов не замораживала страницу. */
    function encodeAll() {
        if (!S.batch || !S.batch.printable.length) return Promise.resolve();
        return LP.ensureBwip().then(function (b) {
            bwip = b;
            var list = S.batch.printable, i = 0;
            return new Promise(function (resolve) {
                (function step() {
                    var end = Math.min(list.length, i + 200);
                    for (; i < end; i++) {
                        var c = list[i].code;
                        if (encCache[c] === undefined) {
                            try { encCache[c] = LM.encode(bwip, { value: c, symbology: 'gs1datamatrix' }); }
                            catch (e) { encCache[c] = null; }
                        }
                    }
                    if (i < list.length) setTimeout(step, 0); else resolve();
                })();
            });
        }).catch(function (e) {
            if (window.__handleError) window.__handleError(e, 'ml_bwip_load', { say: T('err_engine') });
        });
    }

    /* ── формат, модуль, геометрия ───────────────────────────────────────── */
    function currentFmt() {
        if (S.size === 'sheet') return LS.byId(S.sheet) || LS.byId('mk-58x40');
        if (S.size === 'custom') return LS.roll({ w: S.cw, h: S.ch });
        return LS.byId(S.size) || LS.byId('roll-58x40');
    }

    var TR = null;
    function trPrefixes() {
        if (!TR) TR = {
            composition: T('f_composition_p'), size: T('f_size_p'), maker: T('f_maker_p'), country: T('f_country_p'),
            date: T('f_date_p'), care: T('f_care_p'),
        };
        return TR;
    }

    function hasCardText() {
        return !!(S.batch && S.batch.gtins.some(function (g) { var c = S.cards[g.gtin] || {}; return c.name || c.article || c.size || c.color; }));
    }

    /* Пробы для подбора раскладки: по коду на каждый товар (с его карточкой) и
       код с самым широким КИ — то, на чём «помещается» должно держаться для
       всей партии, а не для первой этикетки. */
    function probes() {
        var list = S.batch ? S.batch.printable : [];
        if (!list.length) return [{ code: sampleItem(), card: null }];
        var out = [], seen = {}, widest = null, wW = -1, m = getMeasure();
        for (var i = 0; i < list.length; i++) {
            var it = list[i];
            if (!seen[it.gtin] && out.length < 40) { seen[it.gtin] = 1; out.push({ code: it, card: S.cards[it.gtin] || null }); }
            var w = m('(21)' + (it.serial || ''), { size: MT.KI });
            if (w > wW) { wW = w; widest = it; }
        }
        if (widest) out.push({ code: widest, card: S.cards[widest.gtin] || null });
        return out;
    }

    /* Размер кода, раскладка и вид КИ — одним подбором (MarkingTemplates.fit):
       первый вариант, где на пробах партии ничего не вылезло и не ужалось. */
    function updateGeometry() {
        var fmt = currentFmt();
        var maxCols = 0, rows = 0;
        (S.batch ? S.batch.printable : []).forEach(function (it) {
            var e = encCache[it.code];
            if (e && e.cols > maxCols) { maxCols = e.cols; rows = e.rows; }
        });
        if (!maxCols) { maxCols = 36; rows = 36; }
        var box = MT.dmBoxMax(S.tpl, fmt);
        var maxMm = S.batch && S.batch.printable.length ? S.batch.maxModule : LM.MAX_MODULE_MM;
        var dm = S.dots === 'auto'
            ? MT.dmOptions(S.tpl, fmt, LM, S.dpi, maxCols, rows, maxMm)
            : [{ dots: +S.dots, mm: Math.max(maxCols, rows) * (+S.dots) * 25.4 / S.dpi }];
        var hasText = hasCardText();
        var res = MT.fit(S.tpl, fmt, { dm: dm, ki: S.kiMode, eac: S.eac && S.tpl === 'cz_tr017', hasText: hasText }, probes(), {
            layoutLabel: LL.layoutLabel, measure: getMeasure(), merge: LD.merge, tr: trPrefixes(), dpi: S.dpi, maxModuleMm: maxMm,
        });
        S.fit = res;
        var g = LM.pickDots({ dpi: S.dpi, dots: res.dots, cols: maxCols, rows: rows, boxW: box, boxH: box, quietMm: 0, maxMm: maxMm });
        g.cols = maxCols; g.rows = rows; g.box = box; g.maxMm = maxMm; g.fmt = fmt;
        S.geom = g;
        renderDotsSelect();
        var info = T('dm_info', {
            size: maxCols + '×' + rows, mod: nf(g.moduleMm, 3), dots: g.dots, dpi: S.dpi, mm: nf(g.wMm, 1),
        });
        var warn = [];
        if (g.belowMin) warn.push(T('dm_below_min', { min: nf(LM.MIN_MODULE_MM, 3) }));
        if (g.aboveMax) warn.push(T('dm_above_max', { max: nf(maxMm, 3) }));
        if (dm[0].noFit || g.wMm > box + 1e-6) warn.push(T('dm_no_fit'));
        $('ml-dm-info').innerHTML = esc(info) + (warn.length ? '<br><b class="ml-warn">' + esc(warn.join(' ')) + '</b>' : '');
    }

    function renderDotsSelect() {
        var sel = $('ml-dots');
        var maxMm = S.geom ? S.geom.maxMm : LM.MAX_MODULE_MM;
        var ch = LM.dotChoices(S.dpi, LM.MIN_MODULE_MM, maxMm);
        var want = String(S.dots);
        var html = '<option value="auto">' + esc(T('module_auto_v', { v: S.geom ? nf(S.geom.moduleMm, 3) : '' })) + '</option>';
        ch.forEach(function (c) {
            html += '<option value="' + c.dots + '">' + esc(T('module_opt', { dots: c.dots, mm: nf(c.moduleMm, 3), side: S.geom ? nf(S.geom.cols * c.moduleMm, 1) : '' })) + '</option>';
        });
        sel.innerHTML = html;
        sel.value = ch.some(function (c) { return String(c.dots) === want; }) ? want : 'auto';
        if (sel.value === 'auto' && want !== 'auto') S.dots = 'auto';
    }

    function elementsFor() {
        if (!S.fit) updateGeometry();
        return { fmt: currentFmt(), els: S.fit.elements, kiMode: S.fit.kiMode, issues: S.fit.issues, warnings: S.fit.warnings };
    }

    function recordFor(it, kiMode) {
        return MT.resolveRecord(it, S.cards[it.gtin] || {}, trPrefixes(), kiMode);
    }

    function getMeasure() {
        if (!measure) measure = LR.measurer(familyFor);
        return measure;
    }

    function layoutOne(fmt, els, it, kiMode) {
        var rec = recordFor(it, kiMode);
        return LL.layoutLabel({ w: fmt.w, h: fmt.h }, MT.forRecord(els, rec), {
            measure: getMeasure(),
            resolve: function (el) { return LD.merge(el.text, rec); },
            dpi: S.dpi, dots: S.geom ? S.geom.dots : null,
            maxModuleMm: S.geom ? S.geom.maxMm : null,
        });
    }

    function matrixFor(it) {
        var e = encCache[it.value];
        if (e === undefined && bwip) {
            try { e = encCache[it.value] = LM.encode(bwip, { value: it.value, symbology: 'gs1datamatrix' }); } catch (_) { e = encCache[it.value] = null; }
        }
        return e || null;
    }

    function barcodeUrl(it) {
        var k = LR.barcodeKey(it);
        if (barcodeCache[k] !== undefined) return barcodeCache[k] || null;
        if (!barcodePending[k] && String(it.value || '').length) {
            barcodePending[k] = true;
            LP.ensureBwip().then(function (b) {
                var c = document.createElement('canvas');
                try { b.toCanvas(c, LR.barcodeOptions(it, 3)); barcodeCache[k] = c.toDataURL('image/png'); }
                catch (e) { barcodeCache[k] = ''; }
                renderPreview();
            }).catch(function () { barcodeCache[k] = ''; });
        }
        return null;
    }

    /* ── отрисовка ───────────────────────────────────────────────────────── */
    function renderSources() {
        var host = $('ml-sources');
        var root = $('ml');
        if (root) root.classList.toggle('has-src', S.sources.length > 0);
        if (!S.sources.length) { host.innerHTML = ''; return; }
        host.innerHTML = S.sources.map(function (s) {
            var cnt;
            if (s.busy) cnt = s.progress || T('reading');
            else if (s.error) cnt = T('src_err_' + s.error);
            else cnt = T('src_count', { n: s.items.length }) + (s.pages ? ' · ' + T('src_pages', { n: s.pages }) : '');
            return '<div class="ml-src' + (s.error ? ' bad' : '') + (s.busy ? ' busy' : '') + '">' +
                '<span class="ml-src-n" title="' + esc(s.name) + '">' + esc(s.name) + '</span>' +
                '<span class="ml-src-c">' + esc(cnt) + '</span>' +
                (s.busy ? '' : '<button type="button" class="ml-src-x" data-rm="' + s.id + '" aria-label="' + esc(T('src_remove', { name: s.name })) + '">×</button>') +
                '</div>';
        }).join('');
    }

    function stat(label, value, sub, cls) {
        return '<div class="tc-stat' + (cls ? ' ' + cls : '') + '"><div class="tc-stat-l">' + esc(label) + '</div><div class="tc-stat-v">' + esc(value) + '</div>' + (sub ? '<div class="tc-stat-s">' + esc(sub) + '</div>' : '') + '</div>';
    }
    function msg(text, cls) { return '<p class="tc-msg' + (cls ? ' ' + cls : '') + '">' + text + '</p>'; }

    function renderAnswer() {
        var b = S.batch, v = $('ml-answer-v'), sub = $('ml-answer-sub'), st = $('ml-stats'), ms = $('ml-msgs');
        var busy = S.sources.some(function (s) { return s.busy; });
        if (!b || !b.total) {
            v.textContent = busy ? T('reading') : T('ans_empty');
            sub.textContent = busy ? '' : T('ans_empty_sub');
            st.hidden = true; ms.innerHTML = '';
            $('ml-print').disabled = true;
            $('ml-quick').hidden = true;
            return;
        }
        var ok = b.printable.length;
        v.textContent = T('ans_ready', { n: nf(ok) });
        var gt = b.gtins.length;
        sub.textContent = T('ans_sub', { gtins: nf(gt), files: nf(S.sources.length) });
        st.hidden = false;
        var printedN = b.printable.filter(function (it) { return S.printed[MC.hash(it.code)]; }).length;
        st.innerHTML =
            stat(T('st_ready'), nf(ok), T('st_ready_s', { total: nf(b.total) }), ok ? 'good' : '') +
            stat(T('st_errors'), nf(b.errors), b.errors ? T('st_errors_s') : T('st_none'), b.errors ? 'bad' : '') +
            stat(T('st_dups'), nf(b.duplicates.length), b.duplicates.length ? T('st_dups_s') : T('st_none'), b.duplicates.length ? 'warn' : '') +
            stat(T('st_printed'), nf(printedN), T('st_printed_s', { left: nf(ok - printedN) }), '');
        var out = [];
        // Что пришлось поправить в записи кодов — честно, одной строкой на вид правки.
        var fixed = {}, issues = {};
        allItems().forEach(function (it) {
            it.issues.forEach(function (x) {
                if (x.level === 'info') fixed[x.code] = (fixed[x.code] || 0) + 1;
                else issues[x.code] = (issues[x.code] || 0) + 1;
            });
        });
        Object.keys(issues).forEach(function (code) {
            var lv = code === 'unknown_structure' ? 'warn' : 'bad';
            out.push(msg(esc(T('iss_' + code, { n: nf(issues[code]) })), lv));
        });
        S.sources.forEach(function (s) {
            if (s.missed && s.missed.length) {
                out.push(msg(esc(T('pdf_missed', { name: s.name, n: s.missed.length, pages: uniq(s.missed.map(function (m) { return m.page; })).join(', ') })), 'bad'));
            }
            if (s.notGs1) out.push(msg(esc(T('pdf_not_gs1', { name: s.name, n: s.notGs1 })), 'warn'));
            if (s.badLines && s.badLines.length) out.push(msg(esc(T('bad_lines', { name: s.name, lines: s.badLines.slice(0, 12).join(', ') + (s.badLines.length > 12 ? '…' : '') })), 'bad'));
            if (s.error === 'eps_unreadable') out.push(msg(esc(T('eps_unreadable')), 'warn'));
            if (s.error === 'pdf_no_codes') out.push(msg(esc(T('pdf_no_codes', { name: s.name })), 'bad'));
            if (s.note === 'eps_text') out.push(msg(esc(T('eps_text', { name: s.name })), 'warn'));
        });
        if (b.duplicates.length) {
            var dd = b.duplicates.slice(0, 3).map(function (d) { return d.item.source + (d.item.page ? ' · ' + T('page_n', { n: d.item.page }) : ''); });
            out.push(msg(esc(T('dups_where', { n: b.duplicates.length, where: dd.join('; ') })), 'warn'));
        }
        Object.keys(fixed).forEach(function (code) {
            if (code === 'not_gs1_source') return;
            out.push(msg(esc(T('fix_' + code, { n: nf(fixed[code]) })), 'good'));
        });
        ms.innerHTML = out.join('');
        $('ml-print').disabled = !ok;
        $('ml-quick').hidden = !ok;
    }

    function uniq(a) { var s = {}, o = []; a.forEach(function (x) { if (!s[x]) { s[x] = 1; o.push(x); } }); return o; }

    var renderTimer = null;
    function renderPreview() {
        cancelAnimationFrame(renderTimer);
        renderTimer = requestAnimationFrame(doRenderPreview);
    }
    function doRenderPreview() {
        var host = $('ml-one'), pf = $('ml-preflight');
        var list = S.batch ? S.batch.printable : [];
        var E = elementsFor(), fmt = E.fmt;
        var it = list[S.idx] || sampleItem();
        $('ml-pos').textContent = list.length ? T('pos', { i: S.idx + 1, n: list.length }) : T('pos_sample');
        $('ml-prev').disabled = S.idx <= 0;
        $('ml-next').disabled = S.idx >= list.length - 1;
        var content = layoutOne(fmt, E.els, it, E.kiMode);
        LR.renderLabel(host, { w: fmt.w, h: fmt.h, shape: 'rect', radius: 0 }, content, {
            fontFamilyFor: familyFor, barcodeUrl: barcodeUrl, matrixFor: matrixFor, showSafe: false,
        });
        var svg = host.querySelector('svg');
        if (svg) svg.setAttribute('aria-label', T('preview_of', { size: fmt.w + '×' + fmt.h, ki: it.ki || '' }));
        // Предполётная проверка: чего не хватает шаблону, что не влезает.
        var out = [];
        E.warnings.forEach(function (w) { out.push(msg(esc(T('tw_' + w)), 'warn')); });
        // Подбор КИ — сказано, что сделано, нейтрально: это не ошибка.
        if (S.kiMode === 'auto' && E.kiMode === 'bare') out.push(msg(esc(T('ki_bare_note')), ''));
        if (S.kiMode === 'auto' && E.kiMode === 'off') out.push(msg(esc(T('ki_off_note')), ''));
        content.issues.forEach(function (x) {
            if (x.code === 'text_overflow') out.push(msg(esc(T('pf_overflow', { field: T('fld_' + (x.name || 'text')) })), 'warn'));
            else if (x.code === 'text_tiny') out.push(msg(esc(T('pf_tiny', { field: T('fld_' + (x.name || 'text')), size: nf(x.size, 1) })), 'warn'));
        });
        if (list.length) {
            var missingBy = {}, overBy = {};
            S.batch.gtins.forEach(function (g) {
                var a = MT.audit(S.tpl, S.cards[g.gtin]);
                a.missing.forEach(function (f) { missingBy[f] = (missingBy[f] || 0) + 1; });
                a.tooLong.forEach(function (f) { overBy[f] = (overBy[f] || 0) + 1; });
            });
            // Незаполненные поля — дело, а не беда: одной нейтральной строкой, с кнопкой.
            var mf = Object.keys(missingBy);
            if (mf.length) {
                var same = mf.every(function (f) { return missingBy[f] === missingBy[mf[0]]; });
                var listTxt = mf.map(function (f) { return T('fld_' + f) + (same ? '' : ' — ' + missingBy[f]); }).join(', ');
                out.push(msg(esc(same ? T('pf_missing', { list: listTxt, n: missingBy[mf[0]] }) : T('pf_missing_mixed', { list: listTxt })) +
                    ' <button type="button" class="ml-linkbtn" data-open="ml-products-d">' + esc(T('open_products')) + '</button>', ''));
            }
            Object.keys(overBy).forEach(function (f) { out.push(msg(esc(T('pf_too_long', { field: T('fld_' + f), max: MT.OZON_LIMITS[f] || 30, n: overBy[f] })), 'warn')); });
            if (S.tpl === 'cz_tr017' && S.eac) out.push(msg(esc(T('pf_eac_on')), ''));
        }
        pf.innerHTML = out.join('');
    }

    /* Пример для превью до загрузки кодов: синтетический код длинной структуры. */
    var _sample = null;
    function sampleItem() {
        if (_sample) return _sample;
        var g = '0460000000000' + MC.gtinCheckDigit('0460000000000');
        _sample = MC.parse('01' + g + '21' + '5SAMPLE000001' + MC.GS + '91' + 'TEST' + MC.GS + '92' + 'U0FNUExFIENPREUgLSBET05UIFNUSUNLIElUIEFOWVdIRVJF'.slice(0, 44));
        return _sample;
    }

    function renderRange() {
        var list = S.batch ? S.batch.printable : [];
        var sel = rangeItems();
        var f = currentFmt();
        $('ml-range-sum').textContent = list.length ? T('range_sum', { n: nf(sel.length), size: f.w + '×' + f.h }) : '';
        $('ml-from-wrap').hidden = S.range !== 'from';
        $('ml-print-quick-l').textContent = T('quick_print', { n: nf(sel.length), size: f.w + '×' + f.h, dpi: S.dpi });
    }

    function rangeItems() {
        var list = S.batch ? S.batch.printable : [];
        if (S.range === 'unprinted') return list.filter(function (it) { return !S.printed[MC.hash(it.code)]; });
        if (S.range === 'selected') return list.filter(function (it) { return S.selected[it.code]; });
        if (S.range === 'from') {
            var a = Math.max(1, parseInt($('ml-from').value, 10) || 1), b = parseInt($('ml-to').value, 10) || list.length;
            return list.slice(a - 1, Math.max(a - 1, Math.min(list.length, b)));
        }
        return list.slice();
    }

    /* Таблица кодов: первые 500 строк фильтра — дальше это уже не таблица для глаз. */
    var CODE_ROWS = 500;
    function renderCodes() {
        var b = S.batch, host = $('ml-codes');
        if (!b || !b.total) { host.innerHTML = ''; $('ml-codes-n').textContent = ''; $('ml-codes-more').textContent = ''; return; }
        $('ml-codes-n').textContent = '· ' + nf(b.total);
        var idxOf = {};
        b.printable.forEach(function (it, i) { idxOf[it.code] = i; });
        var rows = [];
        allItems().forEach(function (it) {
            var dup = it.ok && idxOf[it.code] !== undefined && b.printable[idxOf[it.code]] !== it;
            var printed = it.ok && S.printed[MC.hash(it.code)];
            var kind = !it.ok ? 'bad' : (dup ? 'dup' : 'ok');
            if (S.filter === 'bad' && kind !== 'bad') return;
            if (S.filter === 'dup' && kind !== 'dup') return;
            if (S.filter === 'printed' && !(kind === 'ok' && printed)) return;
            if (S.filter === 'unprinted' && !(kind === 'ok' && !printed)) return;
            rows.push({ it: it, kind: kind, n: kind === 'ok' ? idxOf[it.code] + 1 : null, printed: printed });
        });
        var head = '<thead><tr><th></th><th class="num">№</th><th>' + esc(T('col_code')) + '</th><th>' + esc(T('col_where')) + '</th><th>' + esc(T('col_state')) + '</th></tr></thead>';
        var body = rows.slice(0, CODE_ROWS).map(function (r) {
            var it = r.it;
            var state = r.kind === 'bad' ? T('iss_short_' + firstError(it)) : (r.kind === 'dup' ? T('state_dup') : (r.printed ? T('state_printed') : T('state_ready')));
            var where = esc(it.source || '') + (it.page ? ' · ' + esc(T('page_n', { n: it.page })) : (it.line ? ' · ' + esc(T('line_n', { n: it.line })) : ''));
            var codeShow = it.ki ? it.ki : (it.code || it.input || '');
            return '<tr class="' + r.kind + (r.n === S.idx + 1 && r.kind === 'ok' ? ' cur' : '') + '">' +
                '<td>' + (r.kind === 'ok' ? '<input type="checkbox" data-sel="' + esc(it.code) + '"' + (S.selected[it.code] ? ' checked' : '') + ' aria-label="' + esc(T('select_n', { n: r.n })) + '">' : '') + '</td>' +
                '<td class="num">' + (r.n || '—') + '</td>' +
                '<td class="code">' + (r.kind === 'ok' ? '<button type="button" data-show="' + (r.n - 1) + '">' + esc(codeShow) + '</button>' : esc(String(codeShow).slice(0, 120))) + '</td>' +
                '<td>' + where + '</td><td>' + esc(state) + '</td></tr>';
        }).join('');
        host.innerHTML = head + '<tbody>' + body + '</tbody>';
        $('ml-codes-more').textContent = rows.length > CODE_ROWS ? T('codes_more', { n: nf(rows.length - CODE_ROWS) }) : '';
    }
    function firstError(it) {
        for (var i = 0; i < it.issues.length; i++) if (it.issues[i].level === 'error') return it.issues[i].code;
        return 'unknown';
    }

    /* ── карточки товаров по GTIN ────────────────────────────────────────── */
    var CARD_FIELDS = ['name', 'article', 'size', 'color', 'wb', 'ozon', 'composition', 'maker', 'country', 'date', 'care'];
    function cardFieldsFor() {
        if (S.tpl === 'cz_wb') return ['name', 'article', 'size', 'color', 'wb'];
        if (S.tpl === 'cz_ozon') return ['name', 'article', 'size', 'color', 'ozon'];
        if (S.tpl === 'cz_tr017') return ['name', 'article', 'size', 'color', 'composition', 'maker', 'country', 'date', 'care'];
        return ['name', 'article', 'size', 'color'];
    }
    var WIDE_FIELDS = { name: 1, composition: 1, maker: 1, care: 1 };
    function renderCards() {
        var b = S.batch, host = $('ml-cards');
        if (!b || !b.gtins.length) { host.innerHTML = '<p class="tc-hint">' + esc(T('cards_empty')) + '</p>'; $('ml-products-n').textContent = ''; return; }
        $('ml-products-n').textContent = '· ' + nf(b.gtins.length);
        var fields = cardFieldsFor();
        host.innerHTML = b.gtins.map(function (g) {
            var c = S.cards[g.gtin] || {};
            return '<div class="ml-card"><div class="ml-card-h"><span class="ml-card-g">' + esc(g.gtin) + '</span><span class="ml-card-n">' + esc(T('card_codes', { n: nf(g.count) })) + '</span>' +
                (b.gtins.length > 1 ? '<button type="button" class="ml-linkbtn ml-card-only" data-only="' + esc(g.gtin) + '">' + esc(T('card_only')) + '</button>' : '') + '</div>' +
                '<div class="ml-card-f">' + fields.map(function (f) {
                    var lim = S.tpl === 'cz_ozon' ? MT.OZON_LIMITS[f] : null;
                    var v = c[f] || '';
                    return '<label class="tc-f' + (WIDE_FIELDS[f] ? ' w' : '') + '"><span class="tc-f-l">' + esc(T('fld_' + f)) + '</span>' +
                        '<input class="tc-in' + (lim && v.length > lim ? ' over' : '') + '" data-gtin="' + esc(g.gtin) + '" data-f="' + f + '" value="' + esc(v) + '"' +
                        (lim ? ' maxlength="' + (lim + 20) + '"' : '') + ' aria-label="' + esc(T('fld_' + f) + ' · ' + g.gtin) + '" autocomplete="off"></label>';
                }).join('') + '</div></div>';
        }).join('');
    }

    /* Свой Excel/CSV с товарами: колонка GTIN (или штрихкод EAN-13 — GTIN без
       ведущего нуля) находится по данным, остальные — по названиям столбцов. */
    var CARD_HEADERS = {
        name: /наимен|назван|товар|name|title/i, article: /артикул|арт\.|sku|article|vendor ?code/i,
        size: /размер|size/i, color: /цвет|colou?r/i, wb: /баркод|wb|wildberries|вайлд/i, ozon: /ozon|озон|ozn/i,
        composition: /состав|composition|material/i, maker: /изготов|производ|manufacturer|maker/i,
        country: /стран|country|origin/i, date: /дата|date/i, care: /уход|care/i,
    };
    function importCards(file) {
        var p = /\.xlsx?$/i.test(file.name) ? file.arrayBuffer().then(MI.xlsxText) : MI.textOf(file);
        p.then(function (text) {
            var tab = LD.parseTable(text, { header: true, delimiter: /\t/.test(text.split('\n')[0]) ? '\t' : undefined });
            if (!tab.rows || !tab.rows.length) throw new Error('empty_table');
            var fields = tab.fields;
            var gcol = null, best = 0;
            fields.forEach(function (f) {
                var n = 0;
                tab.rows.forEach(function (r) { var v = String(r[f] || '').replace(/\D/g, ''); if (v.length >= 8 && v.length <= 14 && MC.gtinValid(v)) n++; });
                if (n > best) { best = n; gcol = f; }
            });
            if (!gcol || best === 0) { toast(T('cards_no_gtin'), 'warning'); return; }
            var map = {};
            Object.keys(CARD_HEADERS).forEach(function (k) {
                for (var i = 0; i < fields.length; i++) {
                    if (fields[i] !== gcol && CARD_HEADERS[k].test(fields[i]) && !Object.keys(map).some(function (m) { return map[m] === fields[i]; })) { map[k] = fields[i]; break; }
                }
            });
            var hit = 0, known = {};
            (S.batch ? S.batch.gtins : []).forEach(function (g) { known[g.gtin] = 1; });
            tab.rows.forEach(function (r) {
                var v = String(r[gcol] || '').replace(/\D/g, '');
                if (!v) return;
                var g14 = ('00000000000000' + v).slice(-14);
                if (!MC.gtinValid(g14)) return;
                var c = S.cards[g14] || {};
                Object.keys(map).forEach(function (k) { var val = String(r[map[k]] || '').trim(); if (val) c[k] = val; });
                S.cards[g14] = c;
                dbPut('cards', g14, c);
                if (known[g14]) hit++;
            });
            toast(T('cards_imported', { n: hit, cols: Object.keys(map).map(function (k) { return T('fld_' + k); }).join(', ') || '—' }), hit ? 'success' : 'warning');
            feature('ml_cards_import', { rows: tab.rows.length, hit: hit, cols: Object.keys(map).join(',') });
            renderCards(); updateGeometry(); renderPreview();
        }).catch(function (e) {
            if (window.__handleError) window.__handleError(e, 'ml_cards_import', { say: T('cards_import_fail') });
        });
    }

    /* ── печать ──────────────────────────────────────────────────────────── */
    function billKeys(items) {
        var bySrc = {};
        S.sources.forEach(function (s) { bySrc[s.id] = s; });
        var keys = [];
        items.forEach(function (it) {
            var s = bySrc[it.srcId];
            var k = s ? (s.key || setKeyFor(s.kind || 'x', s.items)) : null;
            if (k && keys.indexOf(k) < 0) keys.push(k);
        });
        return keys;
    }

    function begin(items, btn) {
        if (!window.__toolLimit) return { commit: function () {}, abort: function () {} };
        return window.__toolLimit.begin(SLUG, billKeys(items));
    }

    function fileName(base, ext) {
        var N = window.__outputName;
        var s = N && N.sanitize ? N.sanitize(base) : String(base).replace(/[\\/:*?"<>|]+/g, '-');
        return N && N.join ? N.join(s, ext) : s + '.' + ext;
    }

    function print(e) {
        var items = rangeItems();
        if (!items.length) { toast(T('nothing_in_range'), 'warning'); return; }
        var via = e && e.currentTarget && e.currentTarget.id === 'ml-print-quick' ? 'quick' : 'panel';
        var run = begin(items, $(via === 'quick' ? 'ml-print-quick' : 'ml-print'));
        if (!run) return;
        var btn = $('ml-print'), label = btn.textContent, qb = $('ml-print-quick');
        btn.disabled = true; btn.textContent = T('building'); qb.disabled = true;
        var E = elementsFor(), fmt = E.fmt;
        var cells = [];
        var list = S.batch.printable, first = list.indexOf(items[0]) + 1, last = list.indexOf(items[items.length - 1]) + 1;
        Promise.resolve().then(function () {
            return encodeAll();
        }).then(function () {
            items.forEach(function (it) { cells.push(layoutOne(fmt, E.els, it, E.kiMode)); });
            return LP.build({
                fmt: fmt, cells: cells, order: 'row', correction: { scale: 1, dx: S.corr.dx, dy: S.corr.dy },
                outline: false, cutMarks: false, ruler: !LS.isRoll(fmt), rulerCaption: T('ruler_caption'),
            });
        }).then(function (r) {
            var name = fileName(T('file_labels', { size: fmt.w + 'x' + fmt.h, n: items.length }), 'pdf');
            return Promise.resolve(window.__downloadFile ? window.__downloadFile(r.blob, name) : false).then(function (ok) {
                if (ok === false) { run.abort(); return; }
                run.commit();
                S.lastJob = { codes: items.map(function (it) { return it.code; }), first: first, last: last, at: Date.now() };
                showAfter(items.length, first, last, r.pages);
                try {
                    window.__aeToolComplete && window.__aeToolComplete({
                        f: 'pdf', labels: items.length, tpl: S.tpl, size: S.size === 'sheet' ? S.sheet : (S.size === 'custom' ? 'custom' : S.size),
                        dpi: S.dpi, dots: S.geom ? S.geom.dots : null, range: S.range, via: via,
                        corr: (S.corr.dx || S.corr.dy) ? 1 : 0, missed: S.sources.some(function (s) { return s.missed && s.missed.length; }) ? 1 : 0,
                        src: uniq(S.sources.map(function (s) { return s.kind; })).join(','), ext: 'pdf',
                    });
                } catch (_) {}
            });
        }).catch(function (e) {
            run.abort();
            if (window.__handleError) window.__handleError(e, 'ml_pdf_build', { say: T('err_pdf') });
        }).then(function () {
            btn.disabled = !(S.batch && S.batch.printable.length); btn.textContent = label; qb.disabled = false;
        });
    }

    function showAfter(n, a, b, pages) {
        var el = $('ml-after');
        el.hidden = false;
        el.innerHTML = esc(T('after_sent', { n: nf(n), a: a, b: b, pages: nf(pages) })) +
            '<div class="tc-actions ml-mt"><button type="button" class="tc-btn sm" id="ml-after-ok">' + esc(T('after_ok')) + '</button>' +
            '<button type="button" class="tc-btn sm ghost" id="ml-after-jam">' + esc(T('after_jam')) + '</button></div>';
    }

    function markPrinted(codes, on) {
        codes.forEach(function (c) { var h = MC.hash(c); if (on) S.printed[h] = Date.now(); else delete S.printed[h]; });
        renderAnswer(); renderCodes(); renderRange(); saveBatchSoon();
    }

    /* Сдвиг — целое число точек принтера: модули DataMatrix стоят на сетке точек,
       и сдвиг на долю точки сдвигал бы её. Предел ±10 мм — дальше это не сдвиг
       подачи, а не та лента в драйвере. */
    function dotsOf(mm) { return Math.round(mm / (25.4 / S.dpi)); }
    function snapCorr(mm) {
        var v = Math.max(-10, Math.min(10, isFinite(mm) ? mm : 0));
        return Math.round(dotsOf(v) * (25.4 / S.dpi) * 1000) / 1000;
    }
    function renderCorr() {
        var c = S.corr, on = !!(c.dx || c.dy);
        $('ml-corr-dx').value = c.dx ? String(c.dx).replace('.', ',') : '';
        $('ml-corr-dy').value = c.dy ? String(c.dy).replace('.', ',') : '';
        $('ml-corr-sub').textContent = on ? '· ' + T('corr_short', { dx: nf(c.dx, 2), dy: nf(c.dy, 2) }) : '';
        $('ml-corr-out').textContent = on ? T('corr_out', { dx: nf(c.dx, 2), dy: nf(c.dy, 2), ndx: dotsOf(c.dx), ndy: dotsOf(c.dy), dpi: S.dpi }) : T('corr_none');
    }
    function onCorrInput() {
        var p = function (id) { return parseFloat(String($(id).value).replace(',', '.').replace(/[^\d.\-]/g, '')); };
        S.corr = { dx: snapCorr(p('ml-corr-dx')), dy: snapCorr(p('ml-corr-dy')) };
        saveSetting('corr', S.corr);
        renderCorr();
        feature('ml_corr', { set: (S.corr.dx || S.corr.dy) ? 1 : 0 });
    }

    function testLabel() {
        var fmt = currentFmt();
        if (!LS.isRoll(fmt)) fmt = LS.roll({ w: fmt.w, h: fmt.h });
        var g = S.geom || {};
        var sample = sampleCodeFor();
        LP.buildTestPage(fmt, {
            dpi: S.dpi,
            sample: { value: sample, dots: g.dots || null, maxModuleMm: g.maxMm || null },
            caption: T('test_caption', { size: fmt.w + '×' + fmt.h, dpi: S.dpi }),
            rulerCaption: T('test_ruler'),
            lines: [T('test_line_dm', { mod: nf(g.moduleMm || 0, 3), dots: g.dots || '—' })],
            title: T('test_title'),
        }).then(function (r) {
            return window.__downloadFile && window.__downloadFile(r.blob, fileName(T('file_test', { size: fmt.w + 'x' + fmt.h, dpi: S.dpi }), 'pdf'));
        }).then(function () { stage('test_label', { dpi: S.dpi }); })
            .catch(function (e) { if (window.__handleError) window.__handleError(e, 'ml_test_label', { say: T('err_pdf') }); });
    }

    /* Образец кода на тестовой этикетке — СИНТЕТИЧЕСКИЙ, но той же структуры
       и того же размера символа, что у партии: настоящий код партии на
       тестовой наклейке — это второй физический экземпляр кода. */
    function sampleCodeFor() {
        var it = S.batch && S.batch.printable[0];
        var tpl = it && it.template ? it.template : MC.TEMPLATES[0];
        var want = it && encCache[it.code] ? encCache[it.code].cols : 0;
        var g = '0000000000000' + MC.gtinCheckDigit('0000000000000');
        var fills = ['T', 'e', '7', 'Tx7', 'aB3+', 'Q/9'];
        var best = null;
        for (var f = 0; f < fills.length; f++) {
            var parts = tpl.fields.map(function (fd, i) {
                var ai = fd[0] === '335*' ? '3352' : fd[0];
                var v = i === 0 ? g : (/^(8005|3)/.test(ai) ? '000100' : Array(fd[1] + 1).join(fills[f]).slice(0, fd[1]));
                if (fd[0] === '21') v = ('5' + v).slice(0, fd[1]);
                return { ai: ai, value: v };
            });
            var code = MC.joinFields(parts);
            if (!bwip || !want) return code;
            try {
                var e = LM.encode(bwip, { value: code, symbology: 'gs1datamatrix' });
                if (e.cols === want) return code;
                if (!best || Math.abs(e.cols - want) < best.d) best = { code: code, d: Math.abs(e.cols - want) };
            } catch (_) {}
        }
        return best ? best.code : MC.joinFields([{ ai: '01', value: g }, { ai: '21', value: '5TEST' }, { ai: '93', value: 'TEST' }]);
    }

    /* ── выгрузка ────────────────────────────────────────────────────────── */
    function exportFile(kind) {
        var b = S.batch;
        if (!b || !b.printable.length) { toast(T('nothing_to_export'), 'warning'); return; }
        var items = b.printable;
        if (kind === 'gtin') {
            var csv = MC.gtinCsv(b, { headers: [T('h_gtin'), T('h_count'), T('h_name')], nameOf: function (g) { return (S.cards[g] || {}).name || ''; } });
            window.__downloadFile(new Blob([csv], { type: 'text/csv;charset=utf-8' }), fileName(T('file_gtin'), 'csv'));
            feature('ml_export_gtin', { gtins: b.gtins.length });
            return;
        }
        var run = begin(items, $(kind === 'csv' ? 'ml-exp-csv' : 'ml-exp-txt'));
        if (!run) return;
        var blob, name;
        if (kind === 'csv') {
            blob = new Blob([MC.toCsv(items, {
                headers: [T('h_n'), T('h_gtin'), T('h_serial'), T('h_ki'), T('h_code_gs'), T('h_code_b64'), T('h_file'), T('h_printed')],
                printed: function (it) { return !!S.printed[MC.hash(it.code)]; }, printedMark: T('h_printed_yes'),
            })], { type: 'text/csv;charset=utf-8' });
            name = fileName(T('file_codes', { n: items.length }), 'csv');
        } else {
            blob = new Blob([MC.toTxt(items)], { type: 'text/plain;charset=utf-8' });
            name = fileName(T('file_codes', { n: items.length }), 'txt');
        }
        Promise.resolve(window.__downloadFile(blob, name)).then(function (ok) {
            if (ok === false) { run.abort(); return; }
            run.commit();
            try { window.__aeToolComplete && window.__aeToolComplete({ f: 'export_' + kind, labels: items.length, ext: kind }); } catch (_) {}
        }, function () { run.abort(); });
    }

    /* ── камера: проверка и добавление ───────────────────────────────────── */
    var camera = null;
    function cameraBox() {
        if (camera) return camera;
        if (!window.MarkingCamera || !window.CameraManager) return null;
        camera = window.MarkingCamera.create({
            video: $('ml-video'), aim: $('ml-aim'), anchor: $('ml-verify-start'),
            onCodes: onCameraCodes,
            onState: function (s, d) {
                var btn = $('ml-verify-start');
                if (s === 'live') { $('ml-cam').hidden = false; btn.textContent = '⏹ ' + T('verify_stop'); }
                if (s === 'stopped' || s === 'error') { $('ml-cam').hidden = true; btn.textContent = '📷 ' + T(S.camMode === 'add' ? 'cam_add_start' : 'verify_start'); }
                // Итог проверки ленты — одним событием на выключение камеры (счёт, без кодов).
                if (s === 'stopped' && S.camMode === 'verify' && S.verify.order.length) {
                    var V = S.verify, scope = S.lastJob ? S.lastJob.codes : (S.batch ? S.batch.printable.map(function (it) { return it.code; }) : []);
                    feature('ml_verify_done', {
                        read: scope.filter(function (c) { return V.seen[c]; }).length, total: scope.length,
                        foreign: Object.keys(V.foreign).length, no_fnc1: Object.keys(V.notGs1).length, job: S.lastJob ? 1 : 0,
                    });
                }
                if (s === 'error') {
                    feature('ml_cam_failed', { code: d.code || '', mode: S.camMode });
                    // Причину уже сказала записка двери у кнопки (camera.md, «Отказ — один ответ»).
                    if (!(camera && camera.hasHelp())) toast(d.message || T('cam_failed'), 'error');
                }
                if (s === 'live') feature('ml_cam_live', { mode: S.camMode });
            },
        });
        return camera;
    }

    function onCameraCodes(list) {
        if (S.camMode === 'add') {
            var n = addText(list.map(function (x) { return x.text; }).join('\n'), 'camera');
            if (n) { try { navigator.vibrate && navigator.vibrate(30); } catch (_) {} toast(T('cam_added', { n: n }), 'success'); }
            return;
        }
        var V = S.verify, want = {};
        (S.batch ? S.batch.printable : []).forEach(function (it) { want[it.code] = it; });
        list.forEach(function (x) {
            var p = MC.parse(x.text);
            var code = p.code || x.text;
            if (!want[code]) { V.foreign[code] = 1; return; }
            if (!V.seen[code]) { V.seen[code] = Date.now(); V.order.push(code); }
            // Напечатано без FNC1 (]d1) или без GS — касса такой код не примет.
            if (x.symbology && x.symbology !== ']d2') V.notGs1[code] = 1;
            if (p.issues.some(function (i) { return i.code === 'gs_restored'; })) V.notGs1[code] = 1;
        });
        try { navigator.vibrate && navigator.vibrate(20); } catch (_) {}
        renderVerify();
    }

    function renderVerify() {
        var V = S.verify;
        var scope = S.lastJob ? S.lastJob.codes : (S.batch ? S.batch.printable.map(function (it) { return it.code; }) : []);
        var read = scope.filter(function (c) { return V.seen[c]; }).length;
        var missing = scope.filter(function (c) { return !V.seen[c]; });
        var foreign = Object.keys(V.foreign).length, bad = Object.keys(V.notGs1).length;
        $('ml-verify-stats').innerHTML =
            stat(T('v_read'), nf(read) + ' / ' + nf(scope.length), S.lastJob ? T('v_scope_job', { a: S.lastJob.first, b: S.lastJob.last }) : T('v_scope_all'), read && read === scope.length ? 'good' : '') +
            stat(T('v_missing'), nf(missing.length), '', missing.length ? 'warn' : '') +
            stat(T('v_foreign'), nf(foreign), foreign ? T('v_foreign_s') : '', foreign ? 'bad' : '') +
            stat(T('v_bad'), nf(bad), bad ? T('v_bad_s') : '', bad ? 'bad' : '');
        var list = S.batch ? S.batch.printable : [];
        var numOf = {};
        list.forEach(function (it, i) { numOf[it.code] = i + 1; });
        var out = '';
        if (read && missing.length) {
            out += msg(esc(T('v_missing_list', { list: missing.slice(0, 30).map(function (c) { return '№' + numOf[c]; }).join(', ') + (missing.length > 30 ? '…' : '') })), 'warn');
        }
        if (read && !missing.length) out += msg(esc(T('v_all_read')), 'good');
        $('ml-verify-msgs').innerHTML = out;
    }

    /* ── восстановление партии ───────────────────────────────────────────── */
    function restore() {
        return Promise.all([dbAll('cards'), dbAll('batch')]).then(function (r) {
            S.cards = r[0] || {};
            var b = r[1] && r[1].current;
            if (!b || !b.sources || !b.sources.length || S.sources.length) { renderCards(); return; }
            b.sources.forEach(function (s) {
                var src = { id: nextId++, name: s.name, kind: s.kind, key: s.key, pages: s.pages, note: s.note, notGs1: s.notGs1, missed: s.missed || [], items: [] };
                (s.codes || []).forEach(function (c) {
                    var p = MC.parse(c.c);
                    p.source = s.name; p.srcId = src.id; p.page = c.p; p.line = c.l; p.symbology = c.s;
                    src.items.push(p);
                });
                S.sources.push(src);
            });
            S.printed = b.printed || {};
            recompute();
            var n = S.batch ? S.batch.printable.length : 0;
            var when = new Date(b.savedAt || Date.now());
            var note = $('ml-after');
            note.hidden = false;
            note.className = 'tc-msg ml-mt';
            note.innerHTML = esc(T('restored', { n: nf(n), when: when.toLocaleString(window.__intlLocale ? window.__intlLocale() : 'ru') })) +
                ' <button type="button" class="ml-linkbtn" id="ml-clear-batch">' + esc(T('restored_clear')) + '</button>';
            stage('batch_restored', { n: n });
        });
    }

    /* ── события ─────────────────────────────────────────────────────────── */
    function chips(hostId, attr, onPick) {
        var host = $(hostId);
        host.addEventListener('click', function (e) {
            var b = e.target.closest('[data-' + attr + ']');
            if (!b || !host.contains(b)) return;
            host.querySelectorAll('[data-' + attr + ']').forEach(function (x) {
                var on = x === b;
                x.classList.toggle('on', on);
                x.setAttribute('aria-pressed', on ? 'true' : 'false');
            });
            onPick(b.getAttribute('data-' + attr));
        });
    }
    function setChip(hostId, attr, val) {
        $(hostId).querySelectorAll('[data-' + attr + ']').forEach(function (x) {
            var on = x.getAttribute('data-' + attr) === String(val);
            x.classList.toggle('on', on);
            x.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
    }

    var refitTimer = null;
    function refitSoon() {
        clearTimeout(refitTimer);
        refitTimer = setTimeout(function () { updateGeometry(); renderPreview(); }, 250);
    }

    /* Ленты шаблона — те, где он помещается целиком без единого предупреждения
       (перебор держит tests/js/marking-labels-templates.test.mjs); прочее — «Свой». */
    function syncSizes() {
        var allowed = MT.SIZES[S.tpl] || [], hid = 0;
        $('ml-size').querySelectorAll('[data-size]').forEach(function (x) {
            var v = x.getAttribute('data-size');
            var ok = v === 'custom' || v === 'sheet' || allowed.indexOf(v) >= 0;
            x.hidden = !ok;
            if (!ok) hid++;
        });
        var pref = S.sizePref || S.size, note = $('ml-size-note');
        var fits = pref === 'custom' || pref === 'sheet' || !allowed.length || allowed.indexOf(pref) >= 0;
        var want = fits ? pref : allowed[0];
        if (want !== S.size) {
            S.size = want;
            setChip('ml-size', 'size', S.size);
            if (!fits) feature('ml_size_switched', { tpl: S.tpl, from: pref, to: S.size });
        }
        note.textContent = fits ? T('size_tpl_note') : T('size_switched', { from: chipLabel(pref), to: chipLabel(S.size) });
        note.hidden = !hid && fits;
    }
    function chipLabel(id) {
        var b = $('ml-size').querySelector('[data-size="' + id + '"]');
        return b ? b.textContent.trim() : id;
    }

    function onLayoutChange() {
        syncSizes();
        $('ml-custom').hidden = S.size !== 'custom';
        $('ml-sheet-wrap').hidden = S.size !== 'sheet';
        $('ml-eac-wrap').hidden = S.tpl !== 'cz_tr017';
        updateGeometry(); renderPreview(); renderRange(); renderCards();
    }

    function bind() {
        var drop = $('ml-drop');
        if (drop) {
            window.__bindUploaderFile(drop, function (file, detail) {
                var files = (detail && detail.files && detail.files.length) ? detail.files : (file ? [file] : []);
                addFiles(files);
            });
        }
        $('ml-sources').addEventListener('click', function (e) {
            var b = e.target.closest('[data-rm]');
            if (b) removeSource(+b.getAttribute('data-rm'));
        });
        $('ml-paste-open').addEventListener('click', function () {
            var box = $('ml-paste-box'), open = box.hidden;
            box.hidden = !open;
            this.setAttribute('aria-expanded', open ? 'true' : 'false');
            if (open) $('ml-paste').focus();
        });
        $('ml-paste-add').addEventListener('click', function () {
            var v = $('ml-paste').value;
            if (!v.trim()) { $('ml-paste').focus(); return; }
            var n = addText(v, 'paste');
            if (n) { $('ml-paste').value = ''; toast(T('paste_added', { n: n }), 'success'); }
        });
        $('ml-cam-add').addEventListener('click', function () {
            S.camMode = 'add';
            var d = $('ml-verify-d'); d.open = true;
            var c = cameraBox();
            if (!c) { toast(T('cam_failed'), 'error'); return; }
            if (c.running()) c.stop('switch');
            c.start();
            try { d.scrollIntoView({ block: 'nearest' }); } catch (_) {}
        });

        chips('ml-tpl', 'tpl', function (v) { S.tpl = v; saveSetting('tpl', v); onLayoutChange(); feature('ml_setting', { k: 'tpl', v: v }); });
        chips('ml-size', 'size', function (v) { S.size = v; S.sizePref = v; saveSetting('size', v); onLayoutChange(); feature('ml_setting', { k: 'size', v: v }); });
        chips('ml-dpi', 'dpi', function (v) {
            S.dpi = +v; saveSetting('dpi', S.dpi); S.dots = 'auto'; saveSetting('dots', 'auto'); feature('ml_setting', { k: 'dpi', v: S.dpi });
            S.corr = { dx: snapCorr(S.corr.dx), dy: snapCorr(S.corr.dy) }; saveSetting('corr', S.corr); renderCorr();
            onLayoutChange();
        });
        chips('ml-range', 'range', function (v) { S.range = v; renderRange(); feature('ml_setting', { k: 'range', v: v }); });
        chips('ml-filter', 'filter', function (v) { S.filter = v; renderCodes(); });
        $('ml-sheet').addEventListener('change', function () { S.sheet = this.value; saveSetting('sheet', S.sheet); onLayoutChange(); });
        ['ml-cw', 'ml-ch'].forEach(function (id) {
            $(id).addEventListener('change', function () {
                var w = parseFloat(String($('ml-cw').value).replace(',', '.')), h = parseFloat(String($('ml-ch').value).replace(',', '.'));
                var r = LS.roll({ w: w, h: h });
                S.cw = r.w; S.ch = r.h;
                $('ml-cw').value = r.w; $('ml-ch').value = r.h;
                saveSetting('cw', r.w); saveSetting('ch', r.h);
                onLayoutChange();
            });
        });
        $('ml-dots').addEventListener('change', function () { S.dots = this.value; saveSetting('dots', S.dots); updateGeometry(); renderPreview(); });
        $('ml-kimode').addEventListener('change', function () { S.kiMode = this.value; saveSetting('kimode', S.kiMode); updateGeometry(); renderPreview(); feature('ml_setting', { k: 'ki', v: S.kiMode }); });
        $('ml-eac').addEventListener('change', function () { S.eac = this.checked; updateGeometry(); renderPreview(); });
        ['ml-from', 'ml-to'].forEach(function (id) { $(id).addEventListener('input', renderRange); });

        $('ml-prev').addEventListener('click', function () { if (S.idx > 0) { S.idx--; renderPreview(); renderCodes(); } });
        $('ml-next').addEventListener('click', function () { var n = S.batch ? S.batch.printable.length : 0; if (S.idx < n - 1) { S.idx++; renderPreview(); renderCodes(); } });

        $('ml-print').addEventListener('click', print);
        $('ml-print-quick').addEventListener('click', print);
        ['ml-corr-dx', 'ml-corr-dy'].forEach(function (id) { $(id).addEventListener('change', onCorrInput); });
        document.addEventListener('click', function (e) {
            var b = e.target.closest && e.target.closest('.ml [data-open-panel]');
            if (!b) return;
            var pnl = $(b.getAttribute('data-open-panel'));
            if (!pnl) return;
            try { pnl.scrollIntoView({ block: 'nearest' }); } catch (_) {}
            var first = pnl.querySelector('.tc-chip.on, .tc-chip');
            if (first) try { first.focus({ preventScroll: true }); } catch (_) {}
            feature('ml_quick_settings', {});
        });
        $('ml-test').addEventListener('click', testLabel);
        $('ml-exp-csv').addEventListener('click', function () { exportFile('csv'); });
        $('ml-exp-txt').addEventListener('click', function () { exportFile('txt'); });
        $('ml-exp-gtin').addEventListener('click', function () { exportFile('gtin'); });

        $('ml').addEventListener('click', function (e) {
            if (e.target.id === 'ml-after-ok' && S.lastJob) {
                markPrinted(S.lastJob.codes, true);
                feature('ml_after', { a: 'ok', n: S.lastJob.codes.length });
                $('ml-after').innerHTML = esc(T('after_marked', { n: nf(S.lastJob.codes.length) }));
            } else if (e.target.id === 'ml-after-jam' && S.lastJob) {
                feature('ml_after', { a: 'jam', n: S.lastJob.codes.length });
                S.range = 'from'; setChip('ml-range', 'range', 'from');
                $('ml-from').value = S.lastJob.first; $('ml-to').value = S.lastJob.last;
                renderRange();
                $('ml-after').innerHTML = esc(T('after_jam_hint'));
                try { $('ml-from').focus(); } catch (_) {}
            } else if (e.target.id === 'ml-clear-batch') {
                feature('ml_batch_cleared', {});
                S.sources = []; S.printed = {}; S.selected = {}; S.lastJob = null;
                $('ml-after').hidden = true;
                recompute();
            }
        });

        $('ml-codes').addEventListener('change', function (e) {
            var c = e.target.getAttribute('data-sel');
            if (c == null) return;
            if (e.target.checked) S.selected[c] = 1; else delete S.selected[c];
            renderRange();
        });
        $('ml-codes').addEventListener('click', function (e) {
            var b = e.target.closest('[data-show]');
            if (!b) return;
            S.idx = +b.getAttribute('data-show');
            renderPreview(); renderCodes();
            try { $('ml-preview-panel').scrollIntoView({ block: 'nearest' }); } catch (_) {}
        });
        $('ml-sel-all').addEventListener('click', function () { (S.batch ? S.batch.printable : []).forEach(function (it) { S.selected[it.code] = 1; }); renderCodes(); renderRange(); });
        $('ml-sel-none').addEventListener('click', function () { S.selected = {}; renderCodes(); renderRange(); });
        $('ml-mark').addEventListener('click', function () { markPrinted(Object.keys(S.selected), true); });
        $('ml-unmark').addEventListener('click', function () { markPrinted(Object.keys(S.selected), false); });

        /* «Печатать только этот товар»: в одном PDF из СУЗ бывает несколько товаров,
           а клеить сегодня нужно один. Выбор — те же «Выбранные», что и галочки. */
        $('ml-cards').addEventListener('click', function (e) {
            var b = e.target.closest('[data-only]');
            if (!b || !S.batch) return;
            var g = b.getAttribute('data-only'), n = 0;
            S.selected = {};
            S.batch.printable.forEach(function (it) { if (it.gtin === g) { S.selected[it.code] = 1; n++; } });
            S.range = 'selected'; setChip('ml-range', 'range', 'selected');
            renderCodes(); renderRange();
            toast(T('card_only_done', { n: nf(n), gtin: g }), 'success');
            feature('ml_only_gtin', { n: n, gtins: S.batch.gtins.length });
        });
        $('ml-cards').addEventListener('input', function (e) {
            var g = e.target.getAttribute('data-gtin'), f = e.target.getAttribute('data-f');
            if (!g || !f) return;
            var c = S.cards[g] || (S.cards[g] = {});
            c[f] = e.target.value;
            var lim = S.tpl === 'cz_ozon' ? MT.OZON_LIMITS[f] : null;
            e.target.classList.toggle('over', !!(lim && e.target.value.length > lim));
            saveCard(g);
            renderPreview();
            refitSoon();
        });
        $('ml-cards-import').addEventListener('click', function () { $('ml-cards-file').click(); });
        $('ml-cards-file').addEventListener('change', function () { if (this.files && this.files[0]) importCards(this.files[0]); this.value = ''; });

        document.addEventListener('click', function (e) {
            var b = e.target.closest && e.target.closest('.ml [data-open]');
            if (!b) return;
            var d = $(b.getAttribute('data-open'));
            if (d) { d.open = true; try { d.scrollIntoView({ block: 'nearest' }); } catch (_) {} }
        });

        $('ml-verify-start').addEventListener('click', function () {
            var c = cameraBox();
            if (!c) { toast(T('cam_failed'), 'error'); return; }
            if (c.running()) { c.stop('user'); return; }
            if (this.textContent.indexOf(T('cam_add_start')) < 0) S.camMode = 'verify';
            c.start();
        });
        $('ml-verify-reset').addEventListener('click', function () {
            S.verify = { seen: {}, foreign: {}, notGs1: {}, order: [] };
            S.camMode = 'verify';
            renderVerify();
        });
    }

    function init() {
        // Восстановить выбор человека на кнопках.
        setChip('ml-tpl', 'tpl', S.tpl);
        S.sizePref = S.size;
        setChip('ml-size', 'size', S.size);
        setChip('ml-dpi', 'dpi', S.dpi);
        $('ml-sheet').value = S.sheet;
        $('ml-cw').value = S.cw; $('ml-ch').value = S.ch;
        $('ml-kimode').value = S.kiMode;
        bind();
        onLayoutChange();
        renderCorr();
        renderAnswer();
        renderVerify();
        // Шрифт превью — тот же файл, что уйдёт в PDF; раскладку меряем после него.
        Promise.resolve(LR.fontsReady([FAMILY.split(',')[0]])).then(function () { measure = null; updateGeometry(); renderPreview(); });
        LP.ensureBwip().then(function (b) { bwip = b; updateGeometry(); renderPreview(); }).catch(function () {});
        restore().catch(function () {});
        stage('ready');
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
})();
